import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { colours } from "@/utils";
import { Device } from "@/utils/device";
import { CXL } from "@/components/Typography";

type StyleProps = {
  middleImage?: boolean;
  titleContent?: boolean;
};

const CareersHeroContent: FunctionComponent = () => {
  return (
    <S.Section>
      <S.CopyContainer>
        <S.Subtitle>
          <CXL weight="700" colour={colours.shell}>
            Where{" "}
            <S.RoxboroughFontWrap>
              ambition <i>thrives</i>
            </S.RoxboroughFontWrap>
          </CXL>
          <S.Line />
        </S.Subtitle>
        <S.Title>
          Fulfill your <br />
          ambition <br />
          <S.RoxboroughFontWrap>
            <S.ItalicFontWrap>
              with a career <br />
            </S.ItalicFontWrap>
            at AllBright
          </S.RoxboroughFontWrap>
        </S.Title>
      </S.CopyContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  width: 100%;
  background: url(/images/careers/careers-hero.png);
  background-size: cover;
  background-position: 50%;
  padding: 10%;
  aspect-ratio: 1;

  @supports not (aspect-ratio: 1) {
    &:before {
      float: left;
      padding-top: 100%;
      content: "";
    }
    &:after {
      display: block;
      content: "";
      clear: both;
    }
  }

  @media (min-width: ${Device.tablet}) {
    padding: 5% 10% 10% 10%;
    aspect-ratio: auto;

    @supports not (aspect-ratio: auto) {
      &:before {
        float: left;
        padding-top: 0%;
        content: "";
      }
      &:after {
        display: block;
        content: "";
        clear: both;
      }
    }
  }
`;

S.CopyContainer = styled.div<StyleProps>`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 2rem;

  @media (min-width: ${Device.mobile}) {
    gap: 2rem;
  }

  @media (min-width: ${Device.tablet}) {
    height: 100%;
    width: 50%;
    gap: 4rem;
  }

  @media (min-width: ${Device.desktop}) {
    padding: 0 0 5em 0;
    gap: 5rem;
  }
`;

S.RoxboroughFontWrap = styled.span`
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 100;
`;

S.ItalicFontWrap = styled.span`
  font-style: italic;
`;

S.Line = styled.div`
  height: 0.1rem;
  width: 2rem;
  background: ${colours.shell};

  @media (min-width: ${Device.tablet}) {
    width: 3rem;
  }
`;

S.Subtitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

S.Title = styled.h1`
  color: ${colours.shell};

  @media (min-width: ${Device.mobile}) {
    font-size: 3rem;
    line-height: 3.5rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 5rem;
    line-height: 4.8rem;
  }
`;

export default CareersHeroContent;
